import { render, staticRenderFns } from "./loginOtp.vue?vue&type=template&id=f9b39d74"
import script from "./loginOtp.vue?vue&type=script&lang=js"
export * from "./loginOtp.vue?vue&type=script&lang=js"
import style0 from "./loginOtp.vue?vue&type=style&index=0&id=f9b39d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports